import React, { Component } from 'react';
import * as yup from "yup";
import moment from 'moment-timezone';
import { map, filter, isEmpty } from 'lodash';
import Loader from '../../../Common/Component/Loader';
import {errorHandle} from "../../../Common/errorHandle";
import { formatToCurrency } from '../../../../Tools/formatToCurrency'; 

import { DatePicker, message, Select } from 'antd';

const { Option } = Select;
class ViewEditInvoice extends Component {

  state = {
    loader: true,
    single_invoice: {},
    description_data: [],
    other_description: false,
    serviceOrderNumberList: {},
    service_list: '',
    service_order_uuid: '',
    isApprove: false,
    errors: {},
    changedLineItemIndex: -1,
    deletedInvoice:[]
  }

  componentDidMount = () => {
    this.props.getSingleInvoice(this.props.current_invoice_uuid);
    this.props.getInvoiceDescription(this.props.service_order_uuid);
    this.props.getServiceOrderNumberList({ user__uuid: this.props.user_uuid })
    this.setState({
      loader: true
    })
  }


  UNSAFE_componentWillReceiveProps = (props) => {
    // message.destroy();
    // Get Single Invoice
    if (Object.keys(props.SingleInvoice.data).length > 0 && props.SingleInvoice.data !== this.props.SingleInvoice.data) {

      const invoiceData = props.SingleInvoice.data;
      if (invoiceData?.line_items?.length > 0) {
        for (let index = 0; index < invoiceData?.line_items?.length; index++) {
          const descriptionItem = props?.InvoiceDescription?.data?.data?.find(x => x.item === invoiceData?.line_items[index].description && x.type === invoiceData?.line_items[index].item_type);
          if (!descriptionItem) {
            invoiceData.line_items[index].other_description = invoiceData.line_items[index].description;
            invoiceData.line_items[index].description = "other";
          }
        }
      }
      this.setState({
        loader: false,
        service_order_uuid: props?.SingleInvoice?.data?.service_order_uuid,
        single_invoice: props.SingleInvoice.data
      })
    }

    if (Object.keys(props.SingleInvoice.errors).length > 0 && props.SingleInvoice.errors !== this.props.SingleInvoice.errors) {
      errorHandle(props.SingleInvoice.errors)
      this.setState({
        loader: false,
      })
    }

    //Get Invoice Description
    if (Object.keys(props.InvoiceDescription.data).length > 0 && props.InvoiceDescription.data !== this.props.InvoiceDescription.data) {
      this.setState({
        loader: false,
        description_data: props.InvoiceDescription.data
      })
    }

    if (Object.keys(props.InvoiceDescription.errors).length > 0 && props.InvoiceDescription.errors !== this.props.InvoiceDescription.errors) {
      errorHandle(props.InvoiceDescription.errors)
      this.setState({
        loader: false
      })
    }

    // Update Invoice
    if (Object.keys(props.UpdateSingleInvoice.data).length > 0 && props.UpdateSingleInvoice.data !== this.props.UpdateSingleInvoice.data) {
      if (this.state.isApprove) {
        this.props.approveSendInvoice(this.state?.single_invoice?.uuid);
        this.setState({isApprove: false})
      }
      this.setState({single_invoice: {}})
      this.props.getSingleInvoice(this.props.current_invoice_uuid);
    }

    if (Object.keys(props.UpdateSingleInvoice.errors).length > 0 && props.UpdateSingleInvoice.errors !== this.props.UpdateSingleInvoice.errors) {
      errorHandle(props.UpdateSingleInvoice.errors)
      this.setState({
        loader: false,
      })
    }

    //Delete Line Items

    if (Object.keys(props.DeleteLineItems.data).length > 0 && props.DeleteLineItems.data !== this.props.DeleteLineItems.data) {
      this.saveInvoice();
    }

    if (Object.keys(props.DeleteLineItems.errors).length > 0 && props.DeleteLineItems.errors !== this.props.DeleteLineItems.errors) {
      errorHandle(props.DeleteLineItems.errors)
      this.setState({
        loader: false,
      })
    }

    //Get and Finalize Invoice
    if (Object.keys(props.FinalizeInvoice.data).length > 0 && props.FinalizeInvoice.data !== this.props.FinalizeInvoice.data) {
      //Display success message here
      message.success(props?.FinalizeInvoice?.data?.message, 10);
      this.setState({
        loader: false,
      })
    }

    if (Object.keys(props.FinalizeInvoice.errors).length > 0 && props.FinalizeInvoice.errors !== this.props.FinalizeInvoice.errors) {
      errorHandle(props.FinalizeInvoice.errors)
      this.setState({
        loader: false,
      })
    }

    if (Object.keys(props?.Invoice?.errors).length > 0
      && JSON.stringify(props?.Invoice?.errors) !== JSON.stringify(this.props?.Invoice?.errors)) {
      this.setState({loader: false})
      errorHandle(props?.Invoice?.errors)
    }

    // get service order number list
    if (Object.keys(props?.Invoice?.serviceOrderNumberList).length > 0
      && JSON.stringify(props?.Invoice?.serviceOrderNumberList) !== JSON.stringify(this.state.serviceOrderNumberList)) {
      const serviceOrderNumberList = props?.Invoice?.serviceOrderNumberList
      const serviceList = serviceOrderNumberList?.data?.find(x => x.uuid === this.props?.service_order_uuid)
      this.setState({ serviceOrderNumberList: props?.Invoice?.serviceOrderNumberList, serviceList: serviceList?.services });
    }

    // get sales tax
    if (Object.keys(props?.Invoice?.getSalesTax).length > 0
      && JSON.stringify(props?.Invoice?.getSalesTax) !== JSON.stringify(this.props?.Invoice?.getSalesTax)) {
      const {single_invoice, changedLineItemIndex} = this.state;
      let { line_items } = single_invoice;
      line_items[changedLineItemIndex].tax = props?.Invoice?.getSalesTax?.total_tax
      single_invoice.line_items = line_items;
      this.setState({single_invoice}, () => this.calculateTotal())
    }
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  //Calculate total
  calculateTotal = () => {
    let { line_items } = this.state.single_invoice;
    let new_total = 0, salesTax = 0, balance_due = 0, amount_received =  this.state.single_invoice.amount_received;
    map(line_items, x => {
      salesTax = parseFloat(salesTax) + parseFloat(x?.tax)
      new_total = parseFloat(new_total) + parseFloat(x.price || 0)
      balance_due = parseFloat(balance_due) + (parseFloat(x.price || 0) + parseFloat(x.tax || 0))
    })
    this.setState({ single_invoice: {
      ...this.state.single_invoice,
      total: new_total, sales_tax: parseFloat(salesTax).toFixed(2), balance_due: parseFloat(balance_due - amount_received)
    }})
  }


  //Change Tax
  changeTax = (e, data) => {
    let { single_invoice } = this.state;
    let { line_items } = single_invoice;
    let index = line_items.findIndex(x => { return x.uuid === data.uuid });
    line_items[index]['tax_percent'] = e.target.value;
    single_invoice.line_items = line_items;
    this.setState({
      single_invoice
    })
  }

  //Checkbox for change invoice
  isChangeTax = (e, data) => {
    let { single_invoice } = this.state;
    let { line_items } = single_invoice;
    let index = line_items.findIndex(x => { return x.uuid === data.uuid });
    line_items[index]['is_change'] = e.target.checked;
    single_invoice.line_items = line_items;
    this.setState({
      single_invoice
    })
  }

  getSalesTax = (index) => {
    const {single_invoice} = this.state;
    let { line_items } = single_invoice;
    this.setState({changedLineItemIndex: index}, () => {
      if (line_items[index].service_uuid && line_items[index].price && line_items[index].item_type) {
        this.props.getSalesTax({service_uuid: line_items[index].service_uuid, amount: line_items[index].price, item_type: line_items[index].item_type})
      } else if (isEmpty(line_items[index].price)) {
        setTimeout(() => {
          line_items[index].tax = 0
          single_invoice.line_items = line_items;
          this.setState({single_invoice}, () => this.calculateTotal())
        }, 500)
      }
    })
  }

  //store Deleted value//
  deleteInvoice = (uuid)=>{
    let deletedInvoice = this.state.deletedInvoice;
    deletedInvoice.push(uuid);
    this.setState({
      deletedInvoice
    })
  }

  //Edit Invoice Order
  editInvoiceOrder = (e, data) => {
    let { single_invoice } = this.state;
    let { line_items } = single_invoice;
    let index = line_items.findIndex(x => { return x.uuid === data.uuid });
    line_items[index]['is_edit_invoice'] = e;
    single_invoice.line_items = line_items;
    this.setState({
      single_invoice
    }, () => { this.calculateTotal(); })
    console.log('edit invoice', single_invoice)
  }

  //Delte Invoice Order
  deleteInvoiceOrder = (e, data) => {
    let { single_invoice } = this.state;
    let { line_items } = single_invoice;
    let index = line_items.findIndex(x => { return x.uuid === data.uuid });
    line_items.splice(index, 1);
    single_invoice.line_items = line_items;
    this.setState({
      single_invoice
    }, () => { this.calculateTotal(); })
  }

  //Add new Lines

  addNewLineItems = () => {
    let { single_invoice } = this.state;
    let { line_items } = single_invoice;


    line_items.push({
      uuid: line_items.length + 1,
      service_uuid: '',
      invoice_uuid: line_items.length > 0 ? line_items[0]['invoice_uuid'] : '',
      item_type: 'service',
      date: moment(),
      description: "",
      price: "0",
      tax: "0",
      tax_percent: "2.90",
      is_change: true,
      is_new: true,
      is_edit_invoice: true
    })

    single_invoice.line_items = line_items;
    this.setState({
      single_invoice
    }, () => { this.calculateTotal(); })
    console.log('add new line items', single_invoice)
  }

  // on service order change
  onServiceOrderChange = (e) => {
    const {serviceOrderNumberList, single_invoice} = this.state;
    this.props.getServiceOrderById(e)
    this.props.getInvoiceDescription(e)
    this.setState({ 'service_order_uuid': e })
    const serviceList = serviceOrderNumberList?.data?.find(x => x.uuid === e)

    map(single_invoice?.line_items, x => {
      x.is_edit_invoice = true
      const service_num = serviceList?.services?.find(y => y.uuid === x.service_uuid)
      if (isEmpty(service_num)) {
        x.service_uuid = ''
        x.service_code = ''
      }
    })

    this.setState({ 'serviceList': serviceList?.services, single_invoice })
  }

  //Render Invoice Order
  renderInvoiceOrder = () => {
    let { single_invoice, serviceList, errors } = this.state;
    let { is_crud_allow } = this.props;

    return map(single_invoice?.line_items, (item, i) => {
      return (
        <div className="divrow ml-0" key={i}>
          <div className="dcell sno">{(item.is_new || item.is_edit_invoice) ?
            <Select
              dropdownClassName="sm-filter"
              showArrow
              name={'service_uuid'}
              virtual={false}
              style={{ width: '100%' }}
              value={item?.service_uuid ? item?.service_uuid : undefined}
              placeholder={'Select'}
              onChange={(e) => {
                let { line_items } = single_invoice;
                let index = line_items.findIndex(x => { return x.uuid === single_invoice.line_items[i].uuid });
                let service = serviceList.find(x => { return x.uuid === e});
                line_items[index]['service_uuid'] = e;
                line_items[index]['service_code'] = service?.service_code;
                single_invoice.line_items = line_items;
                this.setState({
                  single_invoice
                }, () => this.getSalesTax(i))
              }}
            >
              {map(serviceList, (obj) => <Option value={obj?.uuid} key={obj?.uuid}>{obj?.service_code}</Option>)}
            </Select>: item?.service_code}
          {errors?.[`rows[${i}].service_uuid`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${i}].service_uuid`]}</label> : ''}
          </div>
          <div className="dcell sdate">{(item.is_new || item.is_edit_invoice) ?
            <DatePicker
              allowClear={false}
              value={item.date ? this.UTCToLocal(item.date) : undefined}
              onChange={(e) => {
                let { line_items } = single_invoice;
                let index = line_items.findIndex(x => { return x.uuid === single_invoice.line_items[i].uuid });
                line_items[index]['date'] = moment(e).format('YYYY-MM-DD');
                single_invoice.line_items = line_items;
                this.setState({
                  single_invoice
                })

              }} /> : moment(item?.date).format('MM/DD/YYYY')}
          {errors?.[`rows[${i}].date`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${i}].date`]}</label> : ''}
          </div>
          <div className="dcell stype">
            {(item.is_new || item.is_edit_invoice) ?
              <React.Fragment>
                <div className="fitem-check">
                  <input
                    type="radio"
                    onChange={() => {
                      let { line_items } = single_invoice;
                      line_items[i]['item_type'] = 'product';
                      single_invoice.line_items = line_items;
                      this.setState({
                        single_invoice
                      }, () => this.getSalesTax(i))

                    }}
                    name={`product_type${i}`}
                    id={`{product}${i}`}
                    checked={item?.item_type === 'product'}
                    className="fitem-ck-input" />
                  <label htmlFor={`{product}${i}`} className="fitem-ck-txt">Product</label>
                </div>

                <div className="fitem-check">
                  <input
                    type="radio"
                    id={`{service}${i}`}
                    name={`product_type${i}`}
                    onChange={() => {
                      let { line_items } = single_invoice;
                      line_items[i]['item_type'] = 'service';
                      single_invoice.line_items = line_items;
                      this.setState({
                        single_invoice
                      }, () => this.getSalesTax(i))
                    }}
                    checked={item?.item_type === 'service'}
                    className="fitem-ck-input" />
                  <label htmlFor={`{service}${i}`} className="fitem-ck-txt">Service</label>
                </div>
              </React.Fragment>
              : item?.item_type
            }
            {errors?.[`rows[${i}].item_type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${i}].item_type`]}</label> : ''}
          </div>

          <div className="dcell sdesc">{(item.is_new || item.is_edit_invoice) ?
            <React.Fragment>
              <Select
                className="sdesc"
                value={item.description ? item.description : "Please Select"}
                placeholder="Please Select"
                onChange={(e) => {
                  let { line_items } = single_invoice;
                  let index = line_items.findIndex(x => { return x.uuid === single_invoice.line_items[i].uuid });
                  line_items[index]['description'] = e;
                  single_invoice.line_items = line_items;
                  this.setState({
                    single_invoice
                  })
                }}
              >
                {this.state.description_data?.data?.filter(data => data.type === item?.item_type).map((item) => {
                  return (
                    <Option key={item.item}>{item.item}</Option>
                  )
                })}
                <Option key="other">Other</Option>
              </Select>
              {item.description === "other" ?
                <textarea
                  className="sdesc mt-20"
                  value={item.other_description}
                  onChange={(e) => {
                    let { line_items } = single_invoice;
                    let index = line_items.findIndex(x => { return x.uuid === single_invoice.line_items[i].uuid });
                    line_items[index]['other_description'] = e.target.value;
                    single_invoice.line_items = line_items;
                    this.setState({
                      single_invoice
                    })
                  }}

                ></textarea>
                : null
              }
            </React.Fragment>
            : item?.description === 'other' ? item?.other_description : item?.description}
          {errors?.[`rows[${i}].description`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${i}].description`]}</label> : ''}
          {errors?.[`rows[${i}].other_description`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${i}].other_description`]}</label> : ''}
          </div>
          <div className="dcell sprice">
            <div className="flex ai-center">
              <div className="sprice"> {(item.is_new || item.is_edit_invoice) ?
                <input type="text"
                  value={item?.price}
                  onChange={(e) => {
                    let { line_items } = single_invoice;
                    let index = line_items.findIndex(x => { return x.uuid === single_invoice.line_items[i].uuid });
                    line_items[index]['price'] = e.target.value;
                    single_invoice.line_items = line_items;
                    this.setState({
                      single_invoice
                    }, () => this.getSalesTax(i))

                  }}
                  max='6'
                  maxLength='6'
                  onPaste={(event) => {
                    if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                      event.preventDefault();
                    }
                  }}
                  // onKeyPress={(e) => {
                  //   const pattern = /[0-9]/;
                  //   const inputChar = String.fromCharCode(e.charCode);
                  //   if (!pattern.test(inputChar)
                  //   ) {
                  //     // invalid character, prevent input
                  //     e.preventDefault();
                  //   }
                  // }}

                  className="form-control tax_control"
                /> : `$ ${item?.price}`}
              {errors?.[`rows[${i}].price`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${i}].price`]}</label> : ''}
              </div>
            </div>
          </div>
          <div className="dcell stax">
            <div className="flex ai-center">
              
              <div className="inline-check-list sm-checks">
                <div className="flex ai-center">
                  <div className="sprice">
                    ${formatToCurrency(item?.tax || '0')}
                  </div>
                </div>
                {/* <div className="fitem-check">
                  <input type="checkbox"
                    checked={item.is_change}

                    onChange={(e) => { this.isChangeTax(e, single_invoice.line_items[i]) }}
                    className="fitem-ck-input" id={item?.uuid} name={item?.uuid} />
                  <label htmlFor={item?.uuid} className="fitem-ck-txt"></label>
                </div> */}
                {/* {item.is_change ?
                  <React.Fragment>
                    <div className="fix_isd_code fixed_per_sign">
                      <input type="text"
                        max='6'
                        maxLength='6'
                        onChange={(e) => { this.changeTax(e, single_invoice.line_items[i]) }} value={item?.tax_percent} className="form-control tax_control" />
                      {item?.tax_percent ? <span>%</span> : ''}
                    </div>
                  </React.Fragment> : item?.tax_percent ?   */}
              </div>
            </div>
            <div className="dcell no-min no-wrap">
              {is_crud_allow ? single_invoice.status === "open" || single_invoice.status === "overdue" ? item.is_new ? "" : item.is_edit_invoice ?
                <i className="las la-save ml-0" onClick={() => { this.editInvoiceOrder(false, single_invoice.line_items[i]) }}></i>
                : <i className="las la-edit ml-0" onClick={() => { this.editInvoiceOrder(true, single_invoice.line_items[i]) }}></i> : "" : ""}

              {is_crud_allow && single_invoice.status !== "paid" ? <i onClick={(e) => {
                if (item?.is_new) {
                  this.deleteInvoiceOrder(e, single_invoice.line_items[i]);
                }
                else {
                  this.deleteInvoice(single_invoice.line_items[i]['uuid']);
                  let { line_items } = single_invoice;
                  let index = line_items.findIndex(x => { return x.uuid === single_invoice.line_items[i]['uuid'] });
                  line_items.splice(index, 1);
                  single_invoice.line_items = line_items;
                  this.setState({
                    loader: false,
                    single_invoice
                  })


                }
              }} className="las la-trash-alt cursor_pointer ml-0"></i>
                : ""}

            </div>

          </div>
        </div>
      )

    })

  }

  // validate required fields
  validate = () => {
    const { single_invoice, service_order_uuid } = this.state;

    const rows = single_invoice?.line_items;
    const invoice_date = single_invoice?.invoice_date;
    const due_date = single_invoice?.due_date;

    const schema = yup.object().shape({
      service_order_uuid: yup.string().required('Service order# is required'),
      rows: yup.array(yup.object({
        service_uuid: yup.string().required('Service#  is required'),
        item_type: yup.string().required('Type is required').nullable(),
        date: yup.string().required('Date is required'),
        description: yup.string().required('Description is required'),
        other_description: yup.string().when('description', {
          is: 'other',
          then: yup.string().required('Description is required'),
        }),
        price: yup.string().test('match', 'Price should have a valid format', (price) => {
          return !isNaN(parseFloat(price))
        }),
      })),
      invoice_date: yup.string().required('Invoice Date is required'),
      due_date: yup.string().required('Due Date is required').test("compare", "Invalid due date", (due_date) => moment(invoice_date).isBefore(moment(due_date))),
    });

    const data = { service_order_uuid, rows, invoice_date, due_date };

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({ btn_active: true, errors: {} })
        this.saveInvoice();
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => { err_data[item.path] = item.message })
        this.setState({ errors: err_data, is_btn_active: false })
      });
    }, 500)
  };
  
  // Save Invoice
  saveInvoice = () => {
    this.setState({
      loader: true
    })
    let { single_invoice, service_order_uuid, total} = this.state;
    map(single_invoice?.line_items, (item, i) => {
      // temp_total_sum.push(parseFloat(item.price));



      if (item.is_new) {
        delete single_invoice?.line_items[i]['uuid'];
        delete single_invoice?.line_items[i]['is_new'];
        delete single_invoice?.line_items[i]['is_change'];
      }
      if (!item.tax) {
        item.tax = '0.00'
      }
      if (!item.invoice_uuid) {
        delete single_invoice?.line_items[i]['invoice_uuid'];
      }
      item.date = moment(item.date).format('YYYY-MM-DD')

      if (!item.description) {
        delete single_invoice?.line_items[i]['description'];
      } else if (item.description === "other") {
        item.description = item.other_description;
        delete single_invoice?.line_items[i]['other_description'];
      }
      if (!item.price) {
        item.price = '0.00'
      }
      // if (!item.tax_percent) {
      //   item.tax_percent = '2.90'
      // }

      // if (item.price && item.tax_percent) {
      //   item.tax = parseInt(parseInt(item.price) * item.tax_percent) / 100
      //
      // }

      // temp_sales_tax_sum.push(parseFloat(item.tax));

    })


    // let sales_tax = parseFloat(temp_sales_tax_sum.reduce((a, b) => a + b, 0)).toFixed(2);
    // let total = parseFloat(parseFloat(temp_total_sum.reduce((a, b) => a + b, 0)) + parseFloat(sales_tax)).toFixed(2);
    // let balance_due = parseFloat(total - single_invoice?.amount_received).toFixed(2);


    let data = {
      uuid: single_invoice.uuid,
      line_items: single_invoice?.line_items,
      invoice_date: single_invoice?.invoice_date,
      due_date: single_invoice?.due_date,
      notes: single_invoice?.notes,
      balance_due: parseFloat(total - single_invoice?.amount_received).toFixed(2),
      amount_received: parseFloat(single_invoice?.amount_received).toFixed(2),
      service_order_uuid,
      delete_invoice_line_items:this.state.deletedInvoice,
      // sales_tax,
      // total,
    }

    if (data.line_items) {

      if (!data?.line_items.length > 0) {
        data.total = '0.00'
        data.balance_due = '0.00'
        data.sales_tax = '0.00'
        data.amount_received = '0.00'
      }
    }

    // let is_price_empty = filter(data?.line_items, x => parseFloat(x.price) === 0)
    // if (is_price_empty?.length === 0) {
    // message.success('done')
    this.props.updateSingleInvoice(data)
    // } else {
    //   this.setState({
    //     loader: false
    //   })
    //   message.error('Price should be >0')
    // }
  }

  //Approve and Send invoice
  approveSendInvoice = () => {
    let { single_invoice } = this.state;

    this.props.approveSendInvoice(single_invoice?.uuid);
    this.setState({
      loader: true
    })
  }


  render() {
    let { single_invoice, loader, service_order_uuid, serviceOrderNumberList, errors } = this.state;
    let { is_crud_allow } = this.props;
    const is_payment_recieved = Number(single_invoice?.amount_received || "0") > 0

    return (
      <div className="account_expired_card">
        <ul className="breadcrumb">
          <li onClick={() => { this.props.ChangeComponent(0) }}>
            <span className="pointer"><i className="las la-angle-left"></i> Back to All Accounts</span>
          </li>
        </ul>
        {/* Invoice starts here */}

        <div className="res-body">
          <div className="invoice-container">
            <h4>#{single_invoice?.invoice_id}</h4>
            <div className="flex flex-service">
              <div className="flex-1">
                <div className="bill-add">
                  <b>Bill to:</b>
                  <p>{single_invoice?.user?.first_name} {single_invoice?.user?.last_name} <br />{single_invoice?.billing_address?.address} <br />{single_invoice?.billing_address?.city ? `${single_invoice?.billing_address?.city}, ` : '' } {single_invoice?.billing_address?.state ? `${single_invoice?.billing_address?.state}, ` : ''} {single_invoice?.billing_address?.zip_code ? `${single_invoice?.billing_address?.zip_code}` : ''}</p>
                </div>
              </div>
              <div className="flex-1">
                <div className="form-group">
                  <div className="half-fitem fitem">
                    <div className="half-fitem fitem">
                      <label><b>Service Order#</b></label>
                      <Select
                        disabled = {single_invoice.status === "paid"?true:false}
                        dropdownClassName="sm-filter"
                        showArrow
                        name={'service_order'}
                        virtual={false}
                        style={{ width: '100%' }}
                        value={service_order_uuid ? service_order_uuid : undefined}
                        placeholder={'Service Order#'}
                        onChange={(e) => this.onServiceOrderChange(e)}
                      >
                        {map(serviceOrderNumberList?.data, (obj) => <Option value={obj?.uuid} key={obj?.uuid}>{obj?.service_order_number}</Option>)}
                      </Select>
                      {errors?.['service_order_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['service_order_uuid']}</label> : ''}
                    </div>
                    <div className="half-fitem fitem">
                      <label><b>Invoice Date</b></label>
                      <DatePicker defaultValue={moment()}
                        disabled = {single_invoice.status === "paid"?true:false}
                        onChange={(e) => {
                          single_invoice['invoice_date'] = e ? moment(e).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                          this.setState({
                            single_invoice
                          })
                        }}
                        value={single_invoice?.invoice_date ? moment(single_invoice?.invoice_date) : undefined} format="MM/DD/YYYY" />
                      {errors?.['invoice_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['invoice_date']}</label> : ''}
                    </div>
                    <div className="half-fitem fitem">
                      <label><b>Due Date</b></label>
                      <DatePicker
                        disabled = {single_invoice.status === "paid"?true:false}
                        defaultValue={moment()}
                        onChange={(e) => {
                          single_invoice['due_date'] = e ? moment(e).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                          this.setState({
                            single_invoice
                          })
                        }}
                        value={single_invoice?.due_date ? moment(single_invoice?.due_date) : undefined} format="MM/DD/YYYY" />
                      {errors?.['due_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['due_date']}</label> : ''}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-block">
              <div className="div-table">
                <div className="divhead">
                  <div className="dcell sno">Service #</div>
                  <div className="dcell sdate">Date</div>
                  <div className="dcell stype">Type</div>
                  <div className="dcell sdesc">Description</div>
                  <div className="dcell sprice">Price</div>
                  <div className="dcell stax">Tax</div>
                </div>
                <div className="divbody">

                  {this.renderInvoiceOrder()}

                  <div className="divrow dfoot">
                    <div className="dcell">
                      {single_invoice?.status === 'paid' ?
                        '' :
                        <div className="btn-group">
                          {/* disable the button if crud is not allowed or some payment is recieved */}
                          <button className={(!is_crud_allow || single_invoice.status==="paid") ? "btn btn-brand btn-bdr disbale_btn" : "btn"} disabled={(!is_crud_allow || single_invoice.status==="paid" ) ? true : false} onClick={(e) => { this.addNewLineItems(e) }}>Add Another Line</button>
                          {/* <button className="btn">Clear All</button> */}
                        </div>
                      }
                      {!is_crud_allow || single_invoice?.status==="paid" ? null :
                        <div className="form-group">
                          <div className="fitem">
                            <textarea
                              value={single_invoice?.notes}
                              onChange={(e) => {
                                single_invoice = Object.assign(single_invoice, { notes: e.target.value })
                                this.setState({
                                  single_invoice
                                })
                              }}
                              className="form-control" placeholder="Add a message to your invoice"></textarea>
                          </div>
                        </div>}
                    </div>
                    <div className="dcell flex ai-start flex-end">
                      <div className="price-block">
                        <span>Total</span>
                        <span>Sales Tax</span>
                        <span>Amount Received </span>
                        <span>Balance Due</span>
                      </div>
                      <div className="pricing">
                        {single_invoice?.total ? <span>${formatToCurrency(single_invoice?.total)}</span> : ''}
                        {single_invoice?.sales_tax ? <span>${formatToCurrency(single_invoice?.sales_tax)}</span> : ''}
                        {single_invoice?.amount_received ? <span>${formatToCurrency(single_invoice?.amount_received)}</span> : ''}
                        {single_invoice?.balance_due ? <span>${formatToCurrency(single_invoice?.balance_due)}</span> : ''}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sticky-btn-grp">
              <div className="flex ai-center">
                {single_invoice?.status === 'paid' ?
                  '' :
                  <div className="flex-1">
                    <button className={is_crud_allow ? 'btn' : 'btn btn-brand btn-bdr disbale_btn'} disabled={is_crud_allow || single_invoice.status==="paid" ? false : true} onClick={() => { this.validate() }}>Save</button>
                    <button className={is_crud_allow ? 'btn btn-warning' : 'btn btn-brand btn-bdr disbale_btn'} disabled={is_crud_allow ? false : true} onClick={() => { this.setState({isApprove: true}, () => this.validate() )}}>Approve & Send Invoice</button>
                  </div>}
              </div>
            </div>
          </div>
        </div>
        {/* Invoice ends here */}


        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default ViewEditInvoice;